import React, { useMemo, useCallback } from 'react';
import CustomSizePicker from 'components/shared/CustomSizePicker';

import ui from 'domains/ui';
import canvases from 'domains/canvases';
import activeEditor from 'domains/active_editor';
import {
  selectCatalogsLoaded,
  selectCustomPriceError,
  selectCustomPriceLoading,
  selectOptionsLoaded,
  selectSubcatalogsLoaded,
} from 'selectors/loading_states';

import { validCustomOptions } from 'utils/type_guards';
import { useAppDispatch, useAppSelector } from 'utils/hooks';

import type { Dimension } from 'types/common_types';

function CustomSizePickerContainer() {
  const dispatch = useAppDispatch();
  const catalogsLoaded = useAppSelector(selectCatalogsLoaded);
  const subcatalogsLoaded = useAppSelector(selectSubcatalogsLoaded);
  const optionsLoaded = useAppSelector(selectOptionsLoaded);
  const activeCanvasCustomSizes = useAppSelector(activeEditor.selectors.customSize);
  const customPriceLoading = useAppSelector(selectCustomPriceLoading);
  const customPrice = useAppSelector(activeEditor.selectors.customPrice);
  const customPriceError = useAppSelector(selectCustomPriceError);
  const customPriceErrorMessage = useAppSelector(ui.selectors.customSizeErrors);
  const product = useAppSelector(activeEditor.selectors.product);

  const isLoading = useMemo(() => {
    return !catalogsLoaded || !subcatalogsLoaded || !optionsLoaded;
  }, [catalogsLoaded, subcatalogsLoaded, optionsLoaded]);

  const setCustomSize = useCallback(
    (payload: Partial<Dimension>) => {
      dispatch(canvases.actions.changeActiveCanvasConfig.size(payload));
    },
    [dispatch]
  );

  if (!product || !product.custom_options || !validCustomOptions(product.custom_options))
    return null;

  return (
    <CustomSizePicker
      isLoading={isLoading}
      customPriceLoading={customPriceLoading}
      activeProductCustomOptions={product.custom_options}
      customHeight={activeCanvasCustomSizes.height}
      customWidth={activeCanvasCustomSizes.width}
      customPrice={customPrice}
      showPrice={!customPriceError}
      errorMessage={customPriceErrorMessage}
      setCustomSize={setCustomSize}
    />
  );
}

export default CustomSizePickerContainer;
